require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-upcoming-new-project-featured-in-the-australian.json") })
        }
      }, "path---journal-upcoming-new-project-featured-in-the-australian");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-upcoming-new-project-featured-in-the-australian!./.cache/json/journal-upcoming-new-project-featured-in-the-australian.json
// module id = 551
// module chunks = 231608221292675